import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../../models/config.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private readonly API_URL = environment.frontUrl;
  private config: Config | null = null;

  constructor(private http: HttpClient) {}

  getConfig(): Observable<Config> {
    return this.http.get<Config>(`${this.API_URL}/config/configs.json`);
  }

  getCachedConfig(): Config | null {
    return this.config;
  }

  setCachedConfig(config: Config): void {
    this.config = config;
  }
}